const DEFAULT_MAX_LENGTH = 16;

export const truncateText = (
  text: string,
  maxLength: number = DEFAULT_MAX_LENGTH,
  truncateFromBack: boolean = false,
) => {
  const shouldTruncate = text?.length > maxLength;

  const getTruncatedText = () => {
    if (!shouldTruncate) {
      return text;
    }
    if (truncateFromBack) {
      return `... ${text.slice(-maxLength)}`;
    }
    return `${text.slice(0, maxLength)}...`;
  };

  return {
    shouldTruncate,
    truncatedText: getTruncatedText(),
  };
};
